import BaseElementContainer from "./BaseElementContainer";
import PropTypes from "prop-types";
import React from "react";
import {Box} from "@mui/material";
import VerticalLayout from "../layouts/VerticalLayout";

class TabPanel extends BaseElementContainer {

  render() {
    let a = 0;
    return <VerticalLayout className="CNINFO-TabPanel overflow-y-scroll h-full pb-[12px] pr-[12px]"
                           role="tabpanel"
                           hidden={this.props.value !== this.props.index}
                           id={`simple-tabpanel-${this.props.index}`}
                           ariaLabelledby={`simple-tab-${this.props.index}`}
                           selected={this.props.selected}>
      <Box>{this.props.children}</Box>
    </VerticalLayout>;
  }
}

TabPanel.propTypes = {
  index: PropTypes.number, value: PropTypes.number, selected: PropTypes.bool
};
export default TabPanel;
